// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "common-ui" + "-" + "88f235d5e8661f9aa423" + ".chunk.js";
};